import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { forceCheck } from 'react-lazyload';
import FilterBar from './FilterBar';
import SportTable from './SportTable';
import FavouritesButton from './FavouritesButton';
import FavouritesTooltip from './FavouritesTooltip';
import { HubLiveContainer } from './styles';
import * as types from '../../constants';
import smartSticky from '../../utils/smartSticky';
import HighlightTable from '../../components/HighlightTable';
import LoadingDot from '../../components/LoadingDot';
import { Frame1Mobile } from '../../components/adv/Frame1Mobile';
import DifferentTZS from '../../components/shared/DifferentTZS';

export class HubLive extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      isMobile: false,
      hotjarLoaded: false,
    };
  }

  componentDidMount() {
    this.props.actions.getSportsList(this.props.filterDate, process.env.REACT_APP_SITE);
    this.resizeCallback();
    window.addEventListener('resize', this.resizeCallback);
    if (process.env.REACT_APP_SITE === 'gazzetta') {
      smartSticky('#button-favourites', '.footer', '#favourites-toggle');
    }
    if (process.env.REACT_APP_SITE === 'corriere') {
      smartSticky('#button-favourites', '#main_footer', '#favourites-toggle');
    }
    this.props.actions.setIsDifferentTZS(false);
    this.hotjarLoad();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.resizeCallback);
  }

  resizeCallback = () => {
    this.setState({
      isMobile: window.innerWidth <= this.dynamicBreakPointWindow(process.env.REACT_APP_SITE),
    });
    forceCheck();
  };

  dynamicBreakPointWindow = (site) => {
    if (site === 'gazzetta') {
      return 1023;
    } else if (site === 'fcinter' || site === 'calcionapoli1926' || site === 'forzaroma') {
      return 980;
    } else if (site === 'corriere') {
      return 767;
    } else {
      return 1023;
    }
  };

  hotjarLoad = () => {
    const { hotjarLoaded } = this.state;
    if (!hotjarLoaded && this.props.isLoaded && this.props.loadedAll.size !== 0 && this.props.loadedAll.size === this.props.loadedAll.filter(sport => sport.get('isLoaded') === true).size) {
      this.setState({
        hotjarLoaded: true,
      });
      setTimeout(() => {
        document.body.classList.add('loadedAllLiveHub');
      }, 5000);
    }
  };

  renderSportsTable = (firstAvailable) => (currentSport, index) => {
    const sportTable = (
      <React.Fragment key={index}>
        <SportTable
          actions={this.props.actions}
          allSportsFilter={this.props.allSportsFilter}
          availableSports={this.props.sortedSports}
          className="sportTableLive"
          competitions={this.props.competitions.get(currentSport.get('id').toString())}
          dictionary={this.props.dictionary}
          filterDate={this.props.filterDate}
          filterLive={this.props.filterLive}
          isMobile={this.state.isMobile}
          key={index}
          sportId={currentSport.get('id')}
          sportName={currentSport.get('label')}
          typeTable={types.TYPE_HUB}
          liveSoccerMatches={this.props.liveSoccerMatches}
        />
        {this.state.isMobile && firstAvailable && <Frame1Mobile />}
        {this.state.isMobile && currentSport.get('isSelected') && !firstAvailable && <Frame1Mobile />}
      </React.Fragment>
    );

    if (currentSport.get('isAvailable')) firstAvailable = false;

    return (
      currentSport.get('isAvailable') && 
      (currentSport.get('isSelected') || this.props.allSportsFilter) &&
      sportTable
    );
  }

  render() {
    const {
      actions, availableSports, availableSportsCounter, isLoaded,
      competitions, favouritesCounter, filterDate, location, dictionary, sortedSports, promohighlighted,
      selectedSportsCounter, filterLive, allSportsFilter, showTooltip, liveCounter, highlightedCompetitions, isDifferentTZS,
    } = this.props;
  
    const { isMobile } = this.state;
    let firstAvailable = true;

    return (
      <HubLiveContainer>
        {!isLoaded &&
          <LoadingDot show={!isLoaded} />
        }
        {isLoaded &&
          <React.Fragment>
            {showTooltip &&
              <FavouritesTooltip
                dictionary={dictionary.tooltip}
              />
            }

            <FilterBar
              actions={actions}
              availableSports={availableSports}
              favouritesCounter={favouritesCounter}
              location={location}
              dictionary={dictionary.filterBar}
              filterDate={filterDate}
              filterLive={filterLive}
              allSportsFilter={allSportsFilter}
              availableSportsCounter={availableSportsCounter}
              selectedSportsCounter={selectedSportsCounter}
              isMobile={isMobile}
              liveCounter={liveCounter}
            />

            <div style={{marginBottom: isMobile ? '1em' : '1.9em'}} />

            {(
                promohighlighted && promohighlighted.size > 0 ||
                (
                  highlightedCompetitions && highlightedCompetitions.size === availableSportsCounter && 
                  filterDate.get('value') !== 'yesterday'
                )
              ) && 
                <>
                  <HighlightTable
                    competitions={highlightedCompetitions}
                    filterDate={filterDate}
                    dictionary={dictionary}
                    isMobile={isMobile}
                    actions={actions}
                    isHighlight
                    promohighlighted={promohighlighted}
                  />
                </>
            }

            {sortedSports && sortedSports.size > 0 && 
              <React.Fragment>
                {isDifferentTZS && <DifferentTZS />}
                {sortedSports.map(this.renderSportsTable(firstAvailable))}
              </React.Fragment>
            }

            {sortedSports && sortedSports.filter(sport => sport.get('isAvailable') === true).size === 0 && isLoaded &&
              <span>Non ci sono eventi in programma per oggi, torna domani per seguire i tuoi eventi sportivi preferiti.</span>
            }

            {isMobile && favouritesCounter > 0 &&
              <FavouritesButton
                favouritesCounter={favouritesCounter}
                actions={actions}
                location={location}
              />
            }
          </React.Fragment>
        }
      </HubLiveContainer>
    );
  }
}

HubLive.propTypes = {
  actions: PropTypes.any,
  competitions: PropTypes.any,
  favouritesCounter: PropTypes.number,
  filterDate: PropTypes.object,
  location: PropTypes.any,
  dictionary: PropTypes.any,
  filterLive: PropTypes.any,
  availableSports: PropTypes.any,
  sortedSports: PropTypes.any,
  allSportsFilter: PropTypes.any,
  availableSportsCounter: PropTypes.any,
  selectedSportsCounter: PropTypes.any,
  showTooltip: PropTypes.bool,
  liveCounter: PropTypes.any,
  highlightedCompetitions: PropTypes.any,
  isLoaded: PropTypes.bool,
  loadedAll: PropTypes.any,
  isDifferentTZS: PropTypes.any,
  promohighlighted: PropTypes.any,
};

export default HubLive;
